import React from 'react'
import CenterModal from '../../../components/Modals/center-modal';
import { ReactComponent as CloseIcon } from '../../../assets/close.svg';
import { ReactComponent as Phone3DIcon } from '../../../assets/icons/3d-phone.svg'
import { ReactComponent as CallIcon } from '../../../assets/icons/call.svg';
import { ReactComponent as CallRingIcon } from '../../../assets/icons/Phone_call_ring.svg'

const BookCallModal = ({ show, closeModal, handleSubmit }) => {
    return (
        <CenterModal show={show} closeModal={closeModal} modalClass='!max-w-[450px]  [&>*]:!border-0 [&>*]:!rounded-lg [&>*]:!overflow-hidden' backDropClassName={''}>
            <div className=' relative !p-5'>
                <div>
                    <span>
                        <Phone3DIcon />
                    </span>
                    <button onClick={closeModal} className='absolute right-5 top-5'><CloseIcon /></button>
                </div>

                <div className='!mt-4'>
                    <h4 className='text-xl font-semibold m-0'>Book a Call </h4>
                    <div className='text-black700 text-sm font-medium !mb-3'>If you have doubts regarding the app Subscription purchase or any other doubt. You can book a call with our representative.</div>
                    <div className='!mt-5'>
                        <button
                            className='w-full bg-primary text-white rounded-lg flex items-center justify-center !py-3'
                            onClick={handleSubmit}
                        >
                            <span className='mr-2.5'><CallRingIcon /></span>
                            Book Now
                        </button>
                    </div>
                </div>
            </div>

        </CenterModal>
    )
}

export default BookCallModal;